<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 46 39">
    <defs>
      <path id="a" d="M0 0h46v39H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="b" fill="#fff">
        <use xlink:href="#a" />
      </mask>
      <path
        d="M18.348 35.08V11.754L2.498 7.94v23.325l15.85 3.815ZM6.222 6.269l13.374 3.218L32.971 6.27 19.596 2.547 6.222 6.269ZM26.1 29.01c0-5.516 4.455-9.988 9.95-9.988.217 0 .432.007.645.02V7.94l-15.85 3.814V35.08l6.341-1.526A9.977 9.977 0 0 1 26.1 29.01Zm9.95-7.48c-4.116 0-7.452 3.349-7.452 7.48 0 4.132 3.336 7.482 7.452 7.482s7.453-3.35 7.453-7.482c0-4.17-3.375-7.48-7.453-7.48Zm2.473 3.225c1.163-1.167 2.929.606 1.766 1.773l-2.473 2.482 2.473 2.483c1.163 1.167-.603 2.94-1.766 1.773l-2.473-2.483-2.473 2.483c-1.163 1.167-2.928-.606-1.766-1.773l2.473-2.483-2.473-2.482c-1.162-1.167.604-2.94 1.766-1.773l2.473 2.483 2.473-2.483ZM46 29.011C46 34.528 41.545 39 36.05 39a9.904 9.904 0 0 1-7.34-3.246c-1.113.268-8.744 2.186-9.185 2.156a1.232 1.232 0 0 1-.238-.037L1.071 33.49A1.252 1.252 0 0 1 0 32.25V6.354h.004c0-.548.361-1.051.913-1.204L19.252.049a1.24 1.24 0 0 1 .676-.004l18.348 5.106c.552.153.914.656.913 1.204h.004v13.177A9.99 9.99 0 0 1 46 29.012Z"
        fill="#93AB39"
        mask="url(#b)"
      />
    </g>
  </svg>
</template>
